import { useEffect, useState } from "react";
import Menu from "../Menubar/Menu";
import Modal from 'react-modal';
import "./Jahreszahlen.css";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import UniqueJahr from "./UniqueJahr";
import useKeypress from "../ownHooks/pressEsc";
import { Categories } from "../MainMenu/MenüSicht";

var MonitorApi = require('monitor-api');

export default function MainJahr({ myApiClient, setSection }) {
    const location = useLocation();
    const navigate = useNavigate();
    
    const [jahre, setJahre] = useState([]);
    const [nextYear, setNextYear] = useState([]);
    const [gruppen, setGruppen] = useState();
    const [modal, setModal] = useState(false);

    const [tagesgruppeJahr, setTagesgruppeJahr] = useState([]);

    useEffect(() => {
        setSection('Jährliche Kennzahlen');
      }, [setSection]);

    useEffect(() => {
        console.log("location: ", location)
      }, [location]);


    useEffect(() => {
        const getJahrePromise = () => {
            let getJahre = new Promise((resolve) => {
                let tgZuJahrInstance = new MonitorApi.TagesgruppeZuJahrApi(myApiClient);
                tgZuJahrInstance.getPresentYears((error, data) => {
                    if (error) {
                        console.log(error);
                        resolve(error);
                    } else {
                        console.log(data);
                        resolve(data);
                    }
                })
            });
            getJahre.then((msg) => {
                setJahre(msg);
                setNextYear(Math.max(...msg, 0) + 1);
            });
        }
        getJahrePromise();
        let getGruppen = new Promise((resolve) => {
            let gruppenInstance = new MonitorApi.TagesgruppeApi(myApiClient);
            gruppenInstance.getTagesgruppeTagesgruppeGet((error, data, response) => {
                if (error) {
                console.error(error);
                } else {
                setGruppen(data)
                resolve(data);
                }
            });
        })
        getGruppen.then((gruppenData) => {
            gruppenData.forEach(gruppe => {
                let initTG = new MonitorApi.TagesgruppeJahrCreate();
                initTG.id_gruppe = gruppe.id;
                setTagesgruppeJahr(old => [...old, initTG]);
            })
        })
    }, [myApiClient])

    const newYear = event => {
        event.preventDefault();
        setModal(true);
    }

    const saveNewYear = event => {
        event.preventDefault();
        console.log(tagesgruppeJahr);

        let gruppeZuJahrInstance = new MonitorApi.TagesgruppeZuJahrApi(myApiClient);
        gruppeZuJahrInstance.createTagesgruppenZuJahr(nextYear, tagesgruppeJahr, (error, data) => {
            if (error) {
                console.log(error);
                alert("Irgendwas ging schief...");
            } else {
                console.log(data);
                let getJahre = new Promise((resolve) => {
                    let tgZuJahrInstance = new MonitorApi.TagesgruppeZuJahrApi(myApiClient);
                    tgZuJahrInstance.getPresentYears((error, data) => {
                        if (error) {
                            console.log(error);
                            resolve(error);
                        } else {
                            console.log(data);
                            resolve(data);
                        }
                    })
                });
                getJahre.then((msg) => {
                    setJahre(msg);
                    setNextYear(Math.max(...msg, 0) + 1);
                });
                initStates();

                alert(`Tagesgruppen für ${data.id} eingetragen.`)
            }
        })            
        
    }

    const getInput = event => {
        event.preventDefault();
        console.log(event.target.id, event.target.value)
        if (event.target.value >= 0) {
            const changed = tagesgruppeJahr.filter(tg => tg.id_gruppe === parseInt(event.target.id));
            changed[0].anz_tage = event.target.value;
            setTagesgruppeJahr(old => [...old.filter(tg => tg.id_gruppe !== parseInt(event.target.id)), ...changed])
        }
    }

    const existRemains = () => {
        if (tagesgruppeJahr.filter(tg => tg.anz_tage !== undefined && tg.anz_tage !== "").length === 3) {
            return false
        }
        return true;
    }
    const closeModal = () => {
        initStates();
    }
    useKeypress('Escape', () => {
        closeModal();
    });

    const initStates = () => {
        tagesgruppeJahr.forEach(tg => {
            tg.anz_tage = undefined;
        })
        setModal(false);
    }
    
    const chooseYear = event => {
        event.preventDefault();
        navigate(`../jahreszahlen/${event.target.value}`);
    }

    return (
        <div className="next-to-menu">
            <Menu/>

            <Categories>
                <div className="menu-jz">
                    <h3>Vorhandene Jahre</h3>
                    <ul type="none">
                    {jahre.map(jahr => {
                        return (
                            <li key={jahr} >
                                <button className="bttn-jz" id={jahr} name={jahr} value={jahr} onClick={chooseYear}>{jahr}</button>
                            </li>
                        )
                    })}
                    </ul>

                    <button className="bttn-new-year bttn-jz" onClick={newYear}>&#43; neu {nextYear}</button>
                    <Routes>
                        <Route path={`/:uniqueYear`} element={<UniqueJahr myApiClient={myApiClient}/>} />
                    </Routes>
                </div>

                {modal && <Modal isOpen={modal} className="modal">
                    <button className="bttn-close-modal" onClick={closeModal}>&#10007; </button>

                    <div>
                        <h2>Anlegen eines neues Jahres</h2>
                        <form className="form-jz">
                            <label >neues Jahr: {nextYear}</label>
                            {/* <label >neues Jahr: <input id={'jahr'} type="number" placeholder={nextYear} disabled={true}/></label> */}
                            {/* <label >neues Jahr: <input id={'jahr'} type="number" min={nextYear} onChange={getInputYear} placeholder={nextYear}/></label> */}
                            {gruppen.map(gruppe => 
                                <label key={gruppe.id}>{gruppe.gruppe}: 
                                    <input id={gruppe.id} type="number" min="0" step="1" onChange={getInput}/>
                                </label>
                            )}
                        </form>
                    </div>
                    <button disabled={existRemains()} onClick={saveNewYear}>Speichern</button>
                    <button onClick={closeModal}>Abbrechen</button>        
                </Modal>}
            </Categories>

        </div>
    )
}